import styled from 'styled-components';
import {
    Card,
    Paper,
} from "@mui/material";

export const CardsLegendContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    margin: 0px 0px 25px 0px;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
    overflow: unset !important;
`;

export const CardsLegendItemContainer = styled(Card) <{ $darkMode?: boolean; }>`
    width: 100%;
    padding: 15px;
    display: grid;
    grid-template-columns: 2fr 0.2fr;
    column-gap: 10px;
    justify-items: start;
    box-shadow: 0 0 8px 1px rgb(181 181 181 / 50%) !important;

    .itemDetailsContainer {
        width: 100%;
        text-align: left;
        line-height: 1;

        .itemCount {
            font-size: 25px;
            font-weight: 600;
            display: block;
            color: ${(props) => (props.$darkMode ? '#ced4da' : '#2c3542')};
            margin: 0px 0px 10px 0px;
        }

        .itemTitle {
            font-size: 11.5px;
            font-weight: 600;
            text-transform: uppercase;
            color: #9aa4b2;
            display: block;
        }
    }
    
    .itemIconContainer {
        min-height: unset;
        line-height: 1;
        padding: 5px 5px 1px 5px;
        border-radius: 3px;
        height: fit-content;
    }

    .blueItem {
        background: ${(props) => (props.$darkMode ? '#32ccff26' : '#e0f7ff')};

        svg {
            stroke: #25a0e2;
        }
    }

    .greenItem {
        background: ${(props) => (props.$darkMode ? '#00bd9d26' : '#d9f5f0')};
        
        svg {
            stroke: #00bd9d;
        }
    }

    .yellowItem {
        background: ${(props) => (props.$darkMode ? '#ffbc0a26' : '#fff5da')};
        
        svg {
            stroke: #c9821f;
        }
    }

    .subNote {
        font-size: 12.5px;
        font-weight: 400;
        color: #6b7686;
        display: block;
        grid-column: span 2;
        width: 100%;
        text-align: left;
        margin: 20px 0px 0px 0px;
    }
`;

export const InstanceDetailsContainer = styled.div <{ $darkMode?: boolean; }>`
    .instanceName {
        display: block;
        font-size: 13px;
        font-weight: 700;
        color: #2a7fc0;
        cursor: pointer;
        line-height: 1;
    }
    
    .engineName, .cloneText {
        display: block;
        font-size: 12px;
        font-weight: 400;
        color: #9aa4b2;
        line-height: 1;
        margin: 10px 0px 0px 0px;
    }
        
    .cloneText {
        margin: -4px 0px 11px 0px;
    }

    .dbInstanceName {
        padding: 11px 0px;
        line-height: 1;
        display: block;
    }


    .companyName, .dateText {
        text-transform: uppercase;
    }

    .spDateText {
        padding: 11px 20px;
        line-height: 1;
        display: block;
    }
    
    .alDateText {
        padding: 11px 0px;
        line-height: 1;
        display: block;
    }
    
    .connectionStatus, .schemaHealth, .dbBackupStatus, .spIntegrity, .spStatus, .dbInstancesStatus {
        align-items: center;
        padding: 10px 10px 8px 11px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 700;
        line-height: 1;
        text-transform: uppercase;
    }

    .dbInstancesStatus {
        display: block;
        width: max-content;
        padding: 10px 12px 8px 12px;
    }

    .online, .healthy, .enabled, .valid, .success, .ready {
        background: ${(props) => (props.$darkMode ? '#00bd9d26' : '#d9f5f0')};
        color: #00bd9d;

        .dotText {
            background: #00bd9d;
        }
    }

    .offline, .issues, .failed, .invalid, .failed, .deleted {
        background: ${(props) => (props.$darkMode ? '#f0654826' : '#fde8e4')};
        // color: #d1664f;
        color: #f06548;

        .dotText {
            background: #d1664f;
        }
    }

    .drift, .disabled, .outdated {
        background: ${(props) => (props.$darkMode ? '#ffbc0a26' : '#fff5da')};
        color: #c9821f;

        .dotText {
            background: #c9821f;
        }
    }

    .provisioning {
        background: ${(props) => (props.$darkMode ? '#16314f' : '#e7effb')};
        color: #2a6db5;

        .dotText {
            background: #2a6db5;
        }
    }

    .dbVersion {
        font-family: ui-monospace, 'SFMono-Regular', Menlo, Consolas, monospace !important;
        display: block;
        font-size: 13px;
        font-weight: 700;
        line-height: 1;
    }
    
    .pendingMigrations {
        display: block;
        font-size: 12px;
        font-weight: 400;
        color: #c9821f;
        line-height: 1;
        margin: 10px 0px 0px 0px;
    }

    .dbBackupStatus {
        background: unset !important;
    }

    .schemaHealth, .spStatus {
        display: flex;
        width: max-content;

        .dotText {
            width: 9px;
            height: 9px;
            border-radius: 20px;
            margin: -1px 5px 0px 0px;
        }
    }

    .spIntegrity {
        background: unset !important;
        font-weight: 700;
        font-size: 13px;
        display: block;
        line-height: 1;
        padding: 0px;
    }

    .validCounts {
        display: block;
        font-size: 12px;
        font-weight: 400;
        color: #9aa4b2;
        line-height: 1;
        margin: 10px 0px 0px 0px;
    }

    .spName {
        display: block;
        font-size: 13px;
        font-weight: 700;
        line-height: 1;
    }

    .spErrorText {
        display: block;
        font-size: 12px;
        font-weight: 400;
        color: #f06548;
        line-height: 1;
        margin: 10px 0px 0px 0px;
    }
`;

export const InstanceDetailsPanelContainer = styled.div <{ $darkMode?: boolean; }>`
    display: grid;
    grid-template-columns: 0.1fr 2fr;
    gap: 20px;
    align-items: center;

    .instanceHeaderDetails {
        text-align: left;

        .instanceName {
            display: block;
            // text-transform: uppercase;
            font-size: 16px;
        }

        .companyName {
            display: block;
            font-size: 12px;
            font-weight: 400;
            color: #9aa4b2;

        }
    }

    .subTitle {
        grid-column: span 2;
        display: block;
        font-size: 12px;
        font-weight: 400;
        color: #9aa4b2;
    }
`;

export const InstanceOtherDetailsContainer = styled(Paper) <{ $darkMode?: boolean; }>`
    padding: 15px;
    border-bottom: 1px solid;
    border-radius: 0px !important;
    display: flex;
    gap: 20px;
    background: transparent !important;
    box-shadow: none !important;

    .connectionStatus {
        align-items: center;
        padding: 0px 25px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 700;
        line-height: 1;
        text-transform: uppercase;
        height: 35px;
        align-self: center;
        place-content: center;
    }

    .online {
        background: ${(props) => (props.$darkMode ? '#00bd9d26' : '#d9f5f0')};
        color: #00bd9d;

        .dotText {
            background: #00bd9d;
        }
    }

    .offline {
        background: ${(props) => (props.$darkMode ? '#f0654826' : '#fde8e4')};
        // color: #d1664f;
        color: #f06548;

        .dotText {
            background: #d1664f;
        }
    }

    .engineText, .versionBuildText, .maintenanceModeText {
        display: flex;
        align-items: center;
        padding: 0px 11px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 600;
        line-height: 1;
        color: ${(props) => (props.$darkMode ? '#ced4da' : '#48566a')};
        background: ${(props) => (props.$darkMode ? '#26333f' : '#eef2f7')};
        height: 35px;
        align-self: center;
        place-content: center;

        svg {
            color: ${(props) => (props.$darkMode ? '#ced4da' : '#48566a')};
            margin: 0px 3px 0px 0px;
        }
    }

    .switchContainer {
        display: flex;
        line-height: 1 !impovvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvrtant;
        align-items: center;
        gap: 5px;
        margin-left: auto;

        .switchDetails {
            justify-items: end;

            .switchTitle {
                display: block;
                font-size: 13px;
                font-weight: 700;
                color: #6b7686;
            }
            
            .switchNote {
                display: block;
                font-size: 11px;
                font-weight: 400;
                color: #9aa4b2;
                margin: 5px 0px 0px 0px;
            }
        }
    }

    .maintenanceModeText {
        background: ${(props) => (props.$darkMode ? '#ffbc0a26' : '#fff5da')};
        color: #c9821f;
        border-radius: 20px;

        .dot {
            background: #c9821f;
            width: 8px;
            height: 8px;
            border-radius: 20px;
            margin: 0px 5px 0px 0px;
            place-self: center;
        }
    }
    
    .summaryCountsContainer {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        width: 100%;                            
    }
`;

export const SummaryCountsContainer = styled(Paper) <{ $darkMode?: boolean; }>`
    padding: 0px;
    border-bottom: 1px solid;
    border-radius: 0px !important;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    width: 100%;
    background: transparent !important;
    box-shadow: none !important;

    .summaryCountItem {
        border-right: 1px solid;
        line-height: 1;
        padding: 20px;

        &:last-of-type {
            border: none;
        }
    }
`;

export const SummaryCountItem = styled(Paper) <{ $darkMode?: boolean; }>`
    border-right: 1px solid;
    line-height: 1;
    padding: 20px;
    border-radius: 0px !important;
    box-shadow: none !important;
    background: transparent !important;

    .summaryItemTitle {
        font-size: 12px;
        color: #9aa4b2;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: .04em !important;
        display: block;
    }

    .summaryItemValue {
        font-size: 15px;
        font-weight: 500;
        color: #6b7686;
        display: block;
        margin: 10px 0px 0px 0px;

        .itemVal {
            font-size: 22px;
            font-weight: 700;
            color: ${(props) => (props.$darkMode ? '#ced4da' : '#2c3542')};
        }
    }

    .siv {
        font-weight: 700;
        color: ${(props) => (props.$darkMode ? '#ced4da' : '#2c3542')};
    }

    .latencyText {
        font-size: 22px;
    }

    &:last-of-type {
        border: none;
    }
`;

export const InstanceStatusesContainer = styled(Paper) <{ $darkMode?: boolean; }>`
    padding: 15px;
    border-radius: 0px 0px 4px 4px !important;
    display: flex;
    gap: 20px;
    box-shadow: none !important;
    background: transparent !important;
`;

export const InstanceStatusContainer = styled(Paper) <{ $darkMode?: boolean; $noborderAndPadding?: boolean; $itemOnRight?: boolean; }>`
    border: ${(props) => (props.$noborderAndPadding ? 'none' : '1px solid')};
    padding: ${(props) => (props.$noborderAndPadding ? '0px' : '10px 20px')};
    display: flex;
    gap: 10px;
    box-shadow: none !important;
    line-height: 1;
    align-items: center;
    border-radius: 8px !important;
    background: transparent !important;
    margin-left: ${(props) => (props.$itemOnRight ? 'auto' : '0px')};

    .statusItemText {
        display: flex;
        align-items: center;
        padding: 0px 15px;
        border-radius: 25px;
        font-size: 11px;
        font-weight: 800;
        line-height: 1;
        color: #48566a;
        background: #eef2f7;
        height: 25px;
        align-self: center;
        place-content: center;
        text-transform: uppercase;

        .dot {
            width: 9px;
            height: 9px;
            border-radius: 20px;
            margin: 0px 5px 0px 0px;
            background: ${(props) => (props.$darkMode ? '#ced4da' : '#48566a')};
        }
    }

    .statusText {
        line-height: 1;
        align-items: center;
        font-weight: 700;
        color: ${(props) => (props.$darkMode ? '#ced4da' : '#48566a')};
        font-size: 13px;
    }

    .healthy, .enabled, .noPendingMigrations {
        background: ${(props) => (props.$darkMode ? '#00bd9d26' : '#d9f5f0')};
        color: #00bd9d;

        .dot {
            background: #00bd9d;
        }
    }

    .issues {
        background: ${(props) => (props.$darkMode ? '#f0654826' : '#fde8e4')};
        color: #f06548;

        .dot {
            background: #d1664f;
        }
    }

    .drift, .disabled, .hasPendingMigrations {
        background: ${(props) => (props.$darkMode ? '#ffbc0a26' : '#fff5da')};
        color: #c9821f;

        .dot {
            background: #c9821f;
        }
    }
`;

export const TwoItemsContainer = styled(Paper) <{ $darkMode?: boolean; $noborderAndPadding?: boolean; }>`
    background: transparent !important;
    border: none;
    padding: 0px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: stretch;
    gap: 30px;
    box-shadow: none !important;
    line-height: 1;

    /* Keep both panels the same height: the card fills the grid cell and the
       bordered content body stretches to fill any remaining space. */
    .customDetailsCard {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .customDetailsCard .customStyledPaper {
        flex: 1 1 auto;
    }
`;

export const FieldContainer = styled(Paper) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    padding: 0px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
    box-shadow: none !important;
    line-height: 1;

    .fieldItemContainer {
        .fieldHeader {
            display: block;
            font-size: 12px;
            color: #9aa4b2;
            font-weight: 700;
            margin-bottom: 10px;
        }

        .fieldValue {
            color: ${(props) => (props.$darkMode ? '#ced4da' : '#3a4553')};
            font-size: 13px;
        }
    }
`;

export const SchemaIntegrityItem = styled(Paper) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border-bottom: 1px solid;
    border-radius: 0px !important;
    padding: 15px 0px;
    display: flex;
    gap: 10px;
    box-shadow: none !important;
    line-height: 1;
    align-items: center;

    .successIcon {
        color: #00bd9d;
    }
    
    .warnIcon {
        color: #c9821f;
    }
    
    .errorIcon {
        color: #f06548;
    }

    .integrityItem {
        .integrityItemTitle {
            display: block;
            font-size: 14px;
            font-weight: 700;
            color: ${(props) => (props.$darkMode ? '#ced4da' : '#3a4553')};
        }

        .integrityItemValue {
            display: block;
            color: #9aa4b2;
            font-size: 12.5px;
            margin: 10px 0px 0px 0px;
        }
    }

    &:first-of-type {
        padding: 0px 0px 15px 0px;
    }

    &:last-of-type {
        margin: 0px 0px 20px 0px;
    }
`;

export const SPTableContainer = styled(Paper) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none !important;
    border-radius: 0px !important;
    box-shadow: none !important;

    .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation2.sc-cqgMZH.bqTqbD {
        background: transparent !important;
        border: none !important;
        border-radius: 0px !important;
        box-shadow: none !important;

        // .mantine-Table-root {
        //     thead, tbody {
        //         tr {
        //             th, td {
        //                 &:last-of-type {
        //                     text-align: left !important;
        //                     justify-content: flex-start !important;
        //                 }
        //             }
        //         }
        //     }
        // }
    }
`;

export const ActivityLogsTableContainer = styled(Paper) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none !important;
    border-radius: 0px !important;
    box-shadow: none !important;

    .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation2.sc-cqgMZH.bqTqbD {
        background: transparent !important;
        border: none !important;
        border-radius: 0px !important;
        box-shadow: none !important;

        .mantine-Table-root {
            thead, tbody {
                tr {
                    th, td {
                        &:last-of-type {
                            text-align: left !important;
                            justify-content: flex-start !important;
                        }
                    }
                }
            }
        }
    }
`;

export const AutoBackupHeaderContainer = styled(Paper) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none !important;
    border-radius: 0px !important;
    box-shadow: none !important;
    display: flex;
    gap: 10px;
    align-items: center;

    .enabledText {
        font-weight: 700;
        color: ${(props) => (props.$darkMode ? '#ced4da' : '#6b7686')};
        font-size: 13px;
    }

    .cloneForDebugBtn  {
        .MuiButton-icon.MuiButton-startIcon.MuiButton-iconSizeMedium {
            width: 20px;
            height: 20px;
        }
    }
`;

export const AutoBackupConfigContainer = styled(Paper) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none !important;
    border-radius: 0px !important;
    box-shadow: none !important;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
    padding: 20px;

    .configFieldItem {
        .fieldTitle {
            display: block;
            font-size: 12.5px;
            font-weight: 700;
            color: #9aa4b2;
        }

        .fieldValue {
            display: block;
            font-size: 14.5px;
            font-weight: 700;
            color: ${(props) => (props.$darkMode ? '#ced4da' : '#3a4553')};
        }

        .backupHistoryText {
            margin: 10px 0px 0px 0px;
            font-size: 15px;
            font-weight: 700;
            color: ${(props) => (props.$darkMode ? '#ced4da' : '#2c3542')};
        }
    }

    .threeRowSpan {
        grid-column: span 3;
    }

    .disabledAutoBackup {
        place-items: center;
        text-align: center;

        .iconContainer {
            background: ${(props) => (props.$darkMode ? '#1b2836' : '#f0f2f6')};
            line-height: 1;
            width: 50px;
            height: 50px;
            align-content: center;
            border-radius: 10px;

            svg {
                margin: 0px !important;
                padding: 0px !important;
                line-height: 1;
                color: #b6bfca;
            }
        }

        .alertMessage {
            display: block;
            font-size: 14px;
            font-weight: 400;
            color: #9aa4b2;
            margin: 15px 0px 0px 0px;
        }
    }
`;

export const DbInstancesPanelContainer = styled.div <{ $darkMode?: boolean; }>`
    display: grid;
    grid-template-columns: 0.1fr 2fr;
    column-gap: 20px;
    row-gap: 5px;
    align-items: center;

    .instanceHeaderDetails {
        text-align: left;

        .instanceName {
            display: block;
            // text-transform: uppercase;
            font-size: 16px;
        }

        .companyName {
            display: block;
            font-size: 12px;
            font-weight: 400;
            color: #9aa4b2;

        }
    }

    .subTitle {
        grid-column: span 2;
        display: block;
        font-size: 12px;
        font-weight: 400;
        color: #9aa4b2;
    }
`;

export const StoredProcedureLegendContainer = styled.div <{ $darkMode?: boolean; }>`
    display: flex;
    justify-self: flex-end;

    .legendItemContainer {
        padding: 20px 20px 15px 20px;
        line-height: 1;
        justify-items: center;
        
        .legendCount {
            display: block;
            line-height: 1;
            font-size: 24px;
            font-weight: 700;
            color: ${(props) => (props.$darkMode ? '#ced4da' : '#2c3542')};
        }

        .legendTitle {
            display: block;
            font-size: 11.5px;
            color: #9aa4b2;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: .04em !important;
            margin: 10px 0px 0px 0px;
        }

        .valid {
            color: #00bd9d;
        }
        
        .outdated {
            color: #c9821f;
        }
        
        .invalid {
            color: #f06548;
        }
    }
`;